import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Card,
    Container,
    Dimmer,
    Feed,
    Grid,
    Header,
    Icon,
    Loader,
    Segment
} from "semantic-ui-react";
import { get as loadClock, loadAdminClocks } from "../../reducer/actions";
import { getAdminClocks, isLoading } from "../../reducer";
import moment from "moment";
import { getTranslate } from "react-localize-redux";
import axios from "axios/index";
import { authHeader } from "../../../../helpers/authHeader";


// REQUEST

// Css

class CurrentlyWorking extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeEmployees: []
        }
    }

    componentWillMount() {
        this.props.loadClock();
        this.loadActiveEmployees();
    }

    loadActiveEmployees() {
        const requestOptions = {
            headers: Object.assign(authHeader(), {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }),
        };

        return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/api/clock/active", {}, requestOptions)
            .then(response => {
                return this.setState({ activeEmployees: response.data.data });
            }, () => {
                return this.setState({ activeEmployees: [] });
            });
    }


    render() {
        return (
            <Container style={{padding: '3em 1em'}}>
                <Dimmer active={this.props.isLoading}>
                    <Loader/>
                </Dimmer>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='clock' circular/>
                </Header>
                <Grid
                    textAlign='center'
                    style={{height: '100%'}}
                    verticalAlign='middle'
                >
                    <Grid.Column width={16}>
                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                {this.props.translate('clock.admin.current.header')}
                            </Header>
                            <Segment stacked>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>
                                            {this.props.translate('clock.admin.current.employees')}
                                        </Card.Header>
                                    </Card.Content>
                                    <Card.Content>
                                        {this.state.activeEmployees && this.state.activeEmployees.filter((c) => (c.end === null))
                                            .map((c) => (
                                            <Feed key={c.id}>
                                                <Feed.Event>
                                                    <Feed.Label>
                                                        <Icon name='user'/>
                                                    </Feed.Label>
                                                    <Feed.Content>
                                                        <Feed.Date
                                                            content={moment(c.start, 'YYYY-MM-DD HH:mm:ss').fromNow()}/>
                                                        <Feed.Summary>
                                                            {this.props.translate("clock.admin.current.summary", {
                                                                user: c.user_name,
                                                                activity: c.activity_display_name,
                                                                warehouse: c.warehouse_name
                                                            })}
                                                        </Feed.Summary>
                                                    </Feed.Content>
                                                </Feed.Event>
                                            </Feed>
                                        ))}
                                    </Card.Content>
                                </Card>


                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}


const mapStateToProps = state => ({
    isLoading: isLoading(state),
    clocks: getAdminClocks(state),
    translate: getTranslate(state.localize)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        loadClock: () => (dispatch(loadClock())),
        loadAdminClocks: (start, end) => (dispatch(loadAdminClocks(start, end))),
    })
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CurrentlyWorking)



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/CurrentlyWorking/index.js